/**
 * Manages option button selection state and behavior
 * Handles toggling active states and aria-pressed attributes
 */
export class OptionButtonManager {
  /**
   * @param {HTMLElement} rootElement - The root element containing option buttons
   */
  constructor(rootElement) {
    this.rootElement = rootElement
  }

  /**
   * Select an option button and deselect siblings
   * @param {HTMLButtonElement} button - The button element to select
   */
  selectOption(button) {
    const name = button.getAttribute('name')

    // Remove active from siblings and update aria-pressed
    this.rootElement.querySelectorAll(`button[name="${name}"]`).forEach(el => {
      el.classList.remove('active')
      el.setAttribute('aria-pressed', 'false')
    })

    button.classList.add('active')
    button.setAttribute('aria-pressed', 'true')
  }

  /**
   * Reset all option buttons to their default state
   */
  resetToDefaults() {
    // Reset all option buttons
    this.rootElement.querySelectorAll('.options.active').forEach(el => {
      el.classList.remove('active')
      el.setAttribute('aria-pressed', 'false')
    })
    this.rootElement.querySelectorAll('.options.default').forEach(el => {
      el.classList.add('active')
      el.setAttribute('aria-pressed', 'true')
    })
  }
}
